import { Component, Inject, OnInit } from '@angular/core';
import { ToWords } from 'to-words';
import { FormBuilder } from '@angular/forms';
import { formatDate } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { from, of } from 'rxjs';
import { concatMap, finalize, tap, toArray } from 'rxjs/operators';

@Component({
  selector: 'app-bookinvoice',
  templateUrl: './granth-invoice.component.html',
  styleUrl: './granth-invoice.component.scss'
})
export class GranthInvoiceComponent implements OnInit {
  rep_details;
  viewmode = false;
  date;

  invoiceData = {
    rep_id: 0,
    rep_name: '',
    rep_mobile: '',
    rep_address: '',
    book_data: [],
    invoice_id: '',
    invoice_date: '',
    SGST: 0,
    IGST: 0,
    CGST: 0,
    TOTAL_GST: 0,
  };
  invoiceno = '';
  totalAmount = 0;
  totalCommision = 0;
  cgstamt = 0;
  sgstamt = 0;
  taxablevalue = 0;
  toWords;
  invoiceValue = 0;
  taxAmountInWords;
  isGstinvoice;
  gst_number;
  rep_invoice;
  book_seller_data;
  book_data;
  book_price_total = 0;
  book_sale_price_total = 0;
  book_copies_total = 0;
  shipping_charges_total = 0;
  total_total = 0;
  amtinwords;
  totals = 0;
  val = 0;
  month;
  fullyear;
  nextyear;
  bid = 0;
  customers: any;
  customer: any;

  // ✅ isGranth flag - 'Y' for Granth, 'N' for Book
  isGranth: string = 'Y';

  // ✅ Add tracking for saved invoices
  savedInvoiceNumbers = new Set<string>();

  constructor(
    private fb: FormBuilder,
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<GranthInvoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    debugger
    this.customers = this.data.customerNames || [];
    this.date = this.data.date;
    this.isGstinvoice = this.data['book']?.GST || 'N';
    this.gst_number = this.data['book']?.GST_no || '';
    this.viewmode = this.data['view'] || false;
    this.rep_invoice = this.data['rep_invoice'] || 'N';
    this.invoiceno = this.data.billno || '';

    // ✅ Read isGranth from dialog data ('Y' for Granth, 'N' for Book)
    this.isGranth = this.data.isGranth || 'Y';
    console.log('isGranth flag:', this.isGranth);

    // ✅ Generate invoice numbers for each customer
    this.customers = this.customers.map((cust, index) => {
      const parts = this.invoiceno.split('/');
      const baseNumber = parseInt(parts[2], 10);
      const newNumber = baseNumber + index;

      const lastPart = newNumber < 10 ? '0' + newNumber : newNumber.toString();
      const newInvoiceNo = `${parts[0]}/${parts[1]}/${lastPart}`;

      return {
        name: cust,
        generatedBillNo: newInvoiceNo,
        saved: false
      };
    });

    console.log('Generated Invoice Numbers:', this.customers.map(c => `${c.name}: ${c.generatedBillNo}`));

    if (this.customers.length) {
      const customerNames = this.customers.map(c => c.name);
      this.service.getSingleGranthSellerEntry(customerNames).subscribe((data) => {
        this.book_seller_data = data;

        if (data.length) {
          this.customers.forEach((c) => {
            const seller = this.book_seller_data.find(s => s.name === c.name);
            if (seller) {
              c.bid = seller.bid;
              c.invoiceData = {
                rep_id: seller.id,
                rep_name: seller.name,
                rep_mobile: seller.mob_no,
                rep_address:
                  seller.address + ' ' +
                  seller.taluka + ', ' +
                  seller.district + ', ' +
                  seller.state + ', ' +
                  seller.country + '-' +
                  seller.pincode,
                book_data: seller.delivery_mode,
                SGST: seller.SGST,
                CGST: seller.CGST,
                IGST: seller.IGST,
                gstNumber: seller.gstNumber,
                TOTAL_GST: seller.gstAmount,
                percent: seller.gstPercentage,
                invoice_id: c.generatedBillNo,
                invoice_date: this.date,
              };

              this.getBook(c.bid, c);
            }
          });
        }
      });
    }
  }

  getInvoiceNo() {
    this.service.getBookCustInvoiceId(this.date).subscribe((data) => {
      let value: number;
      if (Object.keys(data).length > 0) {
        value = parseInt(data[0]['invoice_no'].split('/')[2]);
      } else {
        value = 0;
      }

      let selectedDate = new Date(this.date);
      let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
      let year = selectedDate.getFullYear();

      let financialStartYear: number;
      let financialEndYear: number;

      if (selectedDate.getMonth() + 1 < 4) {
        financialStartYear = year - 1;
        financialEndYear = year;
      } else {
        financialStartYear = year;
        financialEndYear = year + 1;
      }

      let startYearShort = financialStartYear.toString().slice(-2);
      let endYearShort = financialEndYear.toString().slice(-2);

      this.invoiceno = `VBD${month}/${startYearShort}-${endYearShort}/${value <= 8 ? '0' + (value + 1) : value + 1}`;
      console.log('Generated Invoice No:', this.invoiceno);
    });
  }

  getBook(id: any, customer?: any) {
    this.service.getgranthBooks(id).subscribe((data) => {
      if (customer) {
        customer.book_data = data;
      }

      let book_price_total = 0;
      let book_sale_price_total = 0;
      let book_copies_total = 0;
      let shipping_charges_total = 0;
      let total_total = 0;

      data.forEach(book => {
        book_price_total += parseInt(book.bookprice || 0);
        book_sale_price_total += parseInt(book.booksaleprice || 0);
        book_copies_total += parseInt(book.bookcopies || 0);
        shipping_charges_total += parseInt(book.shippingcharges || 0);
        total_total += parseInt(book.total || 0);
      });

      customer.book_price_total = book_price_total;
      customer.book_sale_price_total = book_sale_price_total;
      customer.book_copies_total = book_copies_total;
      customer.shipping_charges_total = shipping_charges_total;
      customer.total_total = total_total;
      customer.totals = total_total + shipping_charges_total;

      this.toWords = new ToWords();
      customer.amtinwords = this.toWords.convert(customer.totals, { currency: true });
    });
  }

  printInvoice() {
    const printSectionId = 'print-section';
    const originalContents = document.body.innerHTML;
    const printContents = document.getElementById(printSectionId).innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  }

  saving = false;

  async save() {
    debugger
    if (this.rep_invoice === 'Y') {
      console.log('Rep invoice mode - save disabled');
      return;
    }

    if (this.saving) {
      console.log('Save already in progress...');
      return;
    }

    this.saving = true;

    if (!this.customers || this.customers.length === 0) {
      alert('No customers to save invoice for!');
      this.saving = false;
      return;
    }

    const errors = [];

    try {
      for (const customer of this.customers) {

        if (customer.saved) {
          console.log(`⏭️ Skipping ${customer.name} - already saved (Invoice: ${customer.generatedBillNo})`);
          continue;
        }

        if (this.savedInvoiceNumbers.has(customer.generatedBillNo)) {
          console.warn(`⚠️ Invoice ${customer.generatedBillNo} already saved, skipping ${customer.name}`);
          customer.saved = true;
          continue;
        }

        if (!customer.invoiceData) {
          console.error(`❌ No invoice data for ${customer.name}`);
          errors.push({ customer: customer.name, error: 'No invoice data' });
          continue;
        }

        const invoiceNo = customer.generatedBillNo;
        customer.invoiceData.invoice_id = invoiceNo;

        const invoicePart = parseInt(invoiceNo.split('/')[2]);
        if (isNaN(invoicePart) || !invoiceNo) {
          console.error(`❌ Invalid invoice number for ${customer.name}: ${invoiceNo}`);
          errors.push({ customer: customer.name, error: 'Invalid invoice number' });
          continue;
        }

        customer.invoiceData.invoice_date = this.date;

        console.log(`💾 Saving invoice ${invoiceNo} for ${customer.name} | isGranth: ${this.isGranth}`);

        try {
          // ✅ Pass isGranth as the last argument to InsertCustInvoice
          const invoiceData: any = await this.service.InsertCustInvoice(
            customer.invoiceData.rep_name,
            customer.invoiceData.rep_mobile,
            customer.bid,
            customer.invoiceData.rep_address,
            invoiceNo,
            this.date,
            '',
            '',
            this.gst_number,
            (parseFloat(customer.total_total || 0) + parseFloat(customer.shipping_charges_total || 0)),
            customer.shipping_charges_total || 0,
            this.totalCommision || 0,
            customer.cgstamt || 0,
            customer.cgstamt || 0,
            0,
            this.isGranth  // ✅ 'Y' for Granth, 'N' for Book
          ).toPromise();

          const invoiceId = parseInt(invoiceData['id']);

          if (!invoiceId) {
            throw new Error('Failed to get invoice ID from database');
          }

          // Save books sequentially
          if (customer.book_data && customer.book_data.length > 0) {
            for (const book of customer.book_data) {
              await this.service.InsertCustInvoiceData(
                invoiceId,
                book['bookname'],
                book['authorname'],
                parseInt(book['bookcopies'] || 0),
                parseInt(book['discount'] || 0),
                parseInt(book['discountamt'] || 0),
                parseInt(book['bookprice'] || 0),
                parseInt(book['booksaleprice'] || 0),
                parseInt(book['agentprice'] || 0),
                parseInt(book['yearwisebook'] || 0),
                parseInt(book['total'] || 0),
                parseInt(book['shippingcharges'] || 0),
                parseInt(book['total_amount'] || 0),
                parseInt(book['received_amt'] || 0),
                parseInt(book['remaining_amt']) === 0
                  ? parseInt(book['total'] || 0) + parseInt(book['shippingcharges'] || 0)
                  : parseInt(book['remaining_amt'] || 0),
                parseInt(book['rep_commission_precent'] || 0),
                parseInt(book['rep_commission_amt'] || 0)
              ).toPromise();
            }
          }

          customer.saved = true;
          this.savedInvoiceNumbers.add(invoiceNo);
          console.log(`✅ Invoice ${invoiceNo} saved successfully for ${customer.name}`);

        } catch (err) {
          console.error(`❌ Error saving invoice for ${customer.name}:`, err);
          errors.push({ customer: customer.name, error: err.message || 'Unknown error' });
        }
      }

      if (errors.length === 0) {
        alert('All customers and their books saved successfully!');
        this.dialogRef.close();
      } else {
        const errorMsg = errors.map(e => `${e.customer}: ${e.error}`).join('\n');
        alert(`Some invoices failed to save:\n\n${errorMsg}`);
      }

    } catch (err) {
      console.error('Critical error during save:', err);
      alert('Critical error occurred while saving invoices!');
    } finally {
      this.saving = false;
      console.log('Save process completed. Saved invoices:', Array.from(this.savedInvoiceNumbers));
    }
  }
}